<script lang="ts">
const __DsBlock = {
	name: '$t:blocks.calendar.name',
	icon: 'lucide:calendar',
	category: 'layout',
	type: 'listing-layout',
	hidden: true,
	events: [
		{
			name: 'open',
			payload: [
				{
					name: 'value',
					type: 'object',
					array: false,
					required: true,
				},
			],
		},
		{
			name: 'update:displayOptions',
			payload: [
				{
					name: 'value',
					type: 'object',
					array: false,
					required: true,
				},
			],
		},
	],
}
</script>
<script lang="ts" setup>
import type { CompositePrimaryKey } from '#layers/data-model/public';
import type { CalendarDisplayOptions, SharedLayoutEmits, SharedLayoutProps } from '#layers/listing/public';
import { defineBlock } from '#layers/block-engine/public';
import RenderDisplayTemplate from '#layers/blocks/components/Render/RenderDisplayTemplate.vue';
import { useForwardedLayoutEmits } from '#layers/blocks/composables/use-forwarded-layout-emits';
import { LayoutCalendar } from '#layers/listing/public';

interface LayoutCalendarBlockProps extends SharedLayoutProps<CalendarDisplayOptions> {}

defineProps<LayoutCalendarBlockProps>();

const emit = defineEmits<SharedLayoutEmits>();

const selection = defineModel<CompositePrimaryKey[]>('selection', { default: () => [] });

const forwardedEmits = useForwardedLayoutEmits<SharedLayoutEmits>(emit);

;
</script>

<template>
	<LayoutCalendar
		v-bind="{ ...$props, ...forwardedEmits }"
		v-model:selection="selection"
		:render-display-template="RenderDisplayTemplate"
	/>
</template>
